import get from 'lodash/get';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './Pill.style';

function Pill({ text, color }) {
  const theme = useTheme();
  const bgcolor = get(theme.palette, color);

  return (
    <Styled.Pill sx={{ bgcolor }}>
      <Text size="xs">
        <FormattedMessage id={text} />
      </Text>
    </Styled.Pill>
  );
}

Pill.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

export default Pill;
